(() => {
  if (window.rosalunaBenefitCardsLoaded) return;
  window.rosalunaBenefitCardsLoaded = true;
  const init = (root = document) => {
    root.querySelectorAll('.rosaluna-flip-card').forEach((card) => {
      if (card.querySelector('.rosaluna-flip-toggle')) return;
      const front = card.querySelector('.rosaluna-flip-front');
      const back = card.querySelector('.rosaluna-flip-back');
      if (!front || !back) return;
      const title = front.querySelector('h3')?.textContent.trim() || 'Benefit';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rosaluna-flip-toggle';
      button.innerHTML = '<span class="rosaluna-flip-symbol" aria-hidden="true"></span>';
      button.setAttribute('aria-controls', back.id);
      const setState = (open) => {
        card.classList.toggle('is-flipped', open);
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', `${open ? 'Hide' : 'Read'} ${title} details`);
        front.setAttribute('aria-hidden', String(open));
        back.setAttribute('aria-hidden', String(!open));
      };
      setState(false);
      button.addEventListener('click', () => setState(!card.classList.contains('is-flipped')));
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setState(false);
      });
      card.append(button);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
